module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_02.9997150d.jpg";